import api from 'Application/api/api';

const getProjectDimensionLastRun = signal =>
	api.get('/olap/project-dimension/last-run', {
		signal,
	});

export default getProjectDimensionLastRun;
